import React, { ReactNode } from 'react'

import { Modal } from '@it-incubator/ui-kit'
import { ModalSize } from '@it-incubator/ui-kit/dist/components/modal'

import style from './BasicModal.module.css'

import { useForbidScroll, useKeyDown } from 'common/hooks'

type PropsType = {
  title: string
  children: ReactNode
  isOpen: boolean
  onClose: Function
  size?: ModalSize
}

export const BasicModal = ({ title, children, isOpen, onClose, size = 'lg' }: PropsType) => {
  useKeyDown(onClose, 'Escape')
  useForbidScroll(isOpen)

  const closeModal = () => {
    onClose()
  }

  return (
    <Modal onClose={closeModal} open={isOpen} title={title} size={size}>
      {children}
    </Modal>
  )
}
